import { Button, Form, Modal, Input, Divider, Row, message } from "antd";
import { useState } from "react";
import { db } from "../../firebase";
import { doc, serverTimestamp, updateDoc } from "firebase/firestore";
import TiptapEditor from "./tipTapEditor";
import { EditOutlined } from "@ant-design/icons";
export default function UpdateProductGroupModal({
  groupData,
  fetchData,
  isMobile = false,
  onOpen,
}) {
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const [description, setDescription] = useState();
  const showModal = () => {
    setOpen(true);
    onOpen?.();
    form.setFieldsValue({
      name: groupData?.name,
      description: groupData?.description,
    });
    setDescription(groupData?.description);
  };

  const updateProductGroup = async (value) => {
    try {
      if (!value?.name) {
        return message.error("กรุณากรอกชื่อตัวเลือก");
      }

      const productGroupRef = doc(db, "productGroups", groupData?.key);

      await updateDoc(productGroupRef, {
        name: value?.name,
        // ...(description?.trim() ? { description: description.trim() } : {}),
        updatedAt: serverTimestamp(),
      });
      form?.resetFields();
      fetchData();
      setOpen(false);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      {isMobile ? (
        <Button
          onClick={showModal}
          icon={<EditOutlined />}
          style={{ width: "100%" }}
          className="neo-btn-update-option"
        >
          แก้ไขข้อมูล
        </Button>
      ) : (
        <Button
          onClick={showModal}
          icon={<EditOutlined />}
          className="neo-btn-update-option"
        />
      )}

      {/* MODAL */}
      <Modal
        width={500}
        open={open}
        footer={false}
        closeIcon={false}
        centered
        className="neo-modal"
      >
        <div className="neo-modal-header">
          <div>
            <div className="neo-modal-topline">MANAGEMENT</div>

            <div className="neo-modal-title">📦 แก้ไขชื่อสินค้า</div>
          </div>

          <Button
            className="neo-close-btn"
            onClick={() => {
              setOpen(false);
              form?.resetFields();
            }}
          >
            ✕
          </Button>
        </div>

        <Divider
          style={{
            borderColor: "rgba(255,255,255,0.08)",
            margin: "18px 0px",
          }}
        />

        <Form form={form} layout="vertical" onFinish={updateProductGroup}>
          <div className="neo-form-label">ชื่อสินค้า</div>
          <Form.Item
            name={"name"}
            rules={[
              {
                required: true,
                message: "กรุณากรอกชื่อสินค้า",
              },
            ]}
          >
            <Input placeholder="ชื่อสินค้า" className="neo-input-modal" />
          </Form.Item>
          {/*<div className="neo-form-label">คำอธิบาย</div>
           <Form.Item name="description">
            <TiptapEditor value={description} onChange={setDescription} />
          </Form.Item> */}
          {/* FOOTER BUTTON */}
          <Row justify="space-between" gutter={[12, 12]}>
            {isMobile ? null : (
              <Button
                className="neo-cancel-btn"
                onClick={() => {
                  setOpen(false);
                  form?.resetFields();
                }}
              >
                ยกเลิก
              </Button>
            )}

            <Button
              htmlType="submit"
              className="neo-save-btn"
              style={isMobile ? { width: "100%" } : {}}
            >
              บันทึก
            </Button>
          </Row>
        </Form>
      </Modal>

      {/* STYLE */}
      <style>{`
      /* =========================
   EDIT BUTTON
========================= */

.neo-btn-update-option{
  padding:0 10px !important;

  border-radius:12px !important;

  background:
    rgba(251,191,36,.12) !important;

  border:
    1px solid rgba(251,191,36,.25) !important;

  color:#fbbf24 !important;

  font-size:14px !important;
  font-weight:700 !important;

  transition:.25s;
}

.neo-btn-update-option:hover{
  transform:translateY(-2px);

  background:
    rgba(251,191,36,.18) !important;

  border-color:
    rgba(251,191,36,.4) !important;

  color:#fde68a !important;
}

/* =========================
   MODAL
========================= */

.neo-modal .ant-modal-content{
  background:
    linear-gradient(
      135deg,
      rgba(255,255,255,.10),
      rgba(255,255,255,.03)
    ) !important;

  backdrop-filter:blur(26px);
  -webkit-backdrop-filter:blur(26px);

  border:
    1px solid rgba(255,255,255,.08);

  border-radius:30px;

  padding:26px;

  overflow:hidden;

  box-shadow:
    0 25px 60px rgba(0,0,0,.35);
}

/* =========================
   HEADER
========================= */

.neo-modal-header{
  display:flex;
  justify-content:space-between;
  align-items:flex-start;

  gap:16px;
}

.neo-modal-topline{
  color:#fbbf24;

  font-size:12px;
  font-weight:800;

  letter-spacing:3px;

  text-transform:uppercase;
}

.neo-modal-title{
  color:white;

  font-size:28px;
  font-weight:900;

  line-height:1.1;

  margin-top:4px;
}

.neo-close-btn{
  width:42px;
  height:42px;

  border:none !important;

  border-radius:14px !important;

  background:
    rgba(255,255,255,.08) !important;

  color:white !important;

  transition:.25s;
}

.neo-close-btn:hover{
  background:
    rgba(255,255,255,.14) !important;

  color:white !important;

  transform:rotate(90deg);
}

/* =========================
   TYPOGRAPHY
========================= */

.neo-modal .ant-typography{
  color:white !important;
}

/* =========================
   INPUT
========================= */

.neo-input-modal.ant-input{
  height:52px !important;

  background:
    rgba(255,255,255,.06) !important;

  border:
    1px solid rgba(255,255,255,.08) !important;

  border-radius:16px !important;

  color:white !important;

  box-shadow:none !important;
}

.neo-input-modal.ant-input::placeholder{
  color:#94a3b8;
}

.neo-input-modal.ant-input:focus{
  border-color:#fbbf24 !important;

  box-shadow:
    0 0 0 3px rgba(251,191,36,.12) !important;
}

/* =========================
   TIPTAP
========================= */

.neo-modal .ProseMirror{
  min-height:180px;

  padding:16px;

  border-radius:18px;

  background:
    rgba(255,255,255,.06);

  border:
    1px solid rgba(255,255,255,.08);

  outline:none;
}


.neo-modal .ProseMirror:focus{
  border-color:#fbbf24;
}

/* =========================
   FORM ERROR
========================= */

.neo-modal .ant-form-item-explain-error{
  color:#fca5a5 !important;
}

/* =========================
   DIVIDER
========================= */

.neo-modal .ant-divider{
  border-color:
    rgba(255,255,255,.08) !important;
}

/* =========================
   FOOTER BUTTON
========================= */

.neo-cancel-btn{
  width:48%;
  height:54px;

  border:none !important;

  border-radius:18px !important;

  background:
    rgba(255,255,255,.08) !important;

  color:white !important;

  font-weight:700 !important;

  transition:.25s;
}

.neo-cancel-btn:hover{
  background:
    rgba(255,255,255,.14) !important;

  color:white !important;
}

.neo-save-btn{
  width:48%;
  height:54px;

  border:none !important;

  border-radius:18px !important;

  background:
    linear-gradient(
      135deg,
      #fbbf24,
      #dc2626
    ) !important;

  color:white !important;

  font-weight:800 !important;

  box-shadow:
    0 18px 40px rgba(220,38,38,.35);

  transition:.25s;
}

.neo-save-btn:hover{
  transform:translateY(-2px);

  filter:brightness(1.05);

  color:white !important;
}

/* =========================
   MOBILE
========================= */

@media (max-width: 768px), (min-width: 769px) and (max-width: 1366px) and (pointer: coarse){

  .neo-modal .ant-modal-content{
    padding:20px;
    border-radius:24px;
  }

  .neo-modal-title{
    font-size:22px;
  }

  // .neo-cancel-btn,
  // .neo-save-btn{
  //   width:100%;
  // }

  .neo-cancel-btn{
    margin-bottom:10px;
  }
}
      `}</style>
    </>
  );
}
